import { useState, useEffect } from 'react';
import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';
import { usePaymentStore } from './payment/StripeHelper';
import StripeApplePay from './payment/StripeApplePay';
import StripeGooglePay from './payment/StripeGooglePay';
import StripeCard from './payment/StripeCard';
import SolidgateCard from './payment/SolidgateCard';
import PaddlePayPal from './payment/PaddlePayPal';

const PaymentFormElement = ({ element }) => {
    const { data } = useOnboarding();
    const style = applyStyles(element);
    const [expandedItem, setExpandedItem] = useState(null);

    const isStripeCardAvailable = data?.system?.isStripeEnabled !== false;
    const isSolidgateCardAvailable = data?.system?.isSolidgateEnabled === true;
    const isPaypalAvailable = data?.system?.isPaddleEnabled !== false;

    const pm = usePaymentStore();

    const [isApplePayAvailable, setIsApplePayAvailable] = useState(pm.isApplePayAvailable);
    const [isGooglePayAvailable, setIsGooglePayAvailable] = useState(pm.isGooglePayAvailable);
    const [isLoading, setIsLoading] = useState(pm.isChecking);

    useEffect(() => {

        setIsLoading(pm.isChecking);
        setIsApplePayAvailable(pm.isApplePayAvailable);
        setIsGooglePayAvailable(pm.isGooglePayAvailable);
        console.log("pay: 3 isApplePayAvailable", pm.isApplePayAvailable);
        console.log("pay: 3 isGooglePayAvailable", pm.isGooglePayAvailable);

    }, [pm]);

    useEffect(() => {
        if (!isLoading && !expandedItem) {


            if (isSolidgateCardAvailable) {
                setExpandedItem('solidgateCard');
            }
            else if (isStripeCardAvailable) {
                setExpandedItem('card');
            } 
            else if (isPaypalAvailable) {
                setExpandedItem('paypal');
            }
        }
    }, [isLoading, isApplePayAvailable, isGooglePayAvailable, expandedItem]);

    const handleItemClick = (itemId) => {
        if (expandedItem !== itemId) {
            setExpandedItem(itemId);
        }
    };

    if (isLoading) {
        return (
            <div className="element-payment-form" style={style}>
                <div id="payment-form-loader" className="spinner"></div>
            </div>
        );
    }

    return (
        <div className="element-payment-form" style={style}>
            <form id="payment-form">
                <div className="accordion" id="pay-accordion">

                    {isStripeCardAvailable && (
                        <StripeCard
                            isExpanded={expandedItem === 'card'}
                            onSelect={() => handleItemClick('card')}
                        />
                    )}

                    {isSolidgateCardAvailable && (
                        <SolidgateCard
                            isExpanded={expandedItem === 'solidgateCard'}
                            onSelect={() => handleItemClick('solidgateCard')}
                        />
                    )}

                    {isPaypalAvailable && (
                        <PaddlePayPal
                            isExpanded={expandedItem === 'paypal'}
                            onSelect={() => handleItemClick('paypal')}
                        />
                    )}
                </div>
            </form>
        </div>
    );
};

export default PaymentFormElement;

